import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ImageViewer.scss';
import { getAllowedMessageImageUrl } from '../../../../../utils/messageImageUrl';

const ImageViewer = ({ imageUrl, onClose }) => {
  const source = getAllowedMessageImageUrl(imageUrl);
  if (!source) return null;
  return (
    <div className='image-viewer'>
      <div className='image-viewer-close' onClick={onClose}>
        <button>
          <FontAwesomeIcon icon={['fa', 'times']} />
        </button>
      </div>
      <div className='image-viewer-image'>
        <img src={source} alt='sms-media' referrerPolicy='no-referrer' />
      </div>
    </div>
  );
};

export default ImageViewer;
